const productTypeLists = [
  {
      value: 1,
      text_en: 'Raw Material',
      text_bn: 'কাঁচামাল'
  },
  {
      value: 2,
      text_en: 'Finish Good',
      text_bn: 'ফিনিশ গুড'
  }
]
const registrationStatusList = [
  {
      value: 1,
      text_en: 'Pending',
      text_bn: 'প্রক্রিয়াধীন'
  },
  {
      value: 2,
      text_en: 'Recommended',
      text_bn: 'প্রস্তাবিত'
  },
  {
      value: 3,
      text_en: 'Approved',
      text_bn: 'অনুমোদিত'
  },
  {
      value: 4,
      text_en: 'Deny',
      text_bn: 'অস্বীকার'
  }
]
const monthList = [
  {
    value: 1,
    text_en: 'January',
    text_bn: 'জানুয়ারী'
  },
  {
    value: 2,
    text_en: 'February',
    text_bn: 'ফেব্রুয়ারী'
  },
  {
    value: 3,
    text_en: 'March',
    text_bn: 'মার্চ'
  },
  {
    value: 4,
    text_en: 'April',
    text_bn: 'এপ্রিল'
  },
  {
    value: 5,
    text_en: 'May',
    text_bn: 'মে'
  },
  {
    value: 6,
    text_en: 'June',
    text_bn: 'জুন'
  },
  {
    value: 7,
    text_en: 'July',
    text_bn: 'জুলাই'
  },
  {
    value: 8,
    text_en: 'August',
    text_bn: 'আগস্ট'
  },
  {
    value: 9,
    text_en: 'September',
    text_bn: 'সেপ্টেম্বর'
  },
  {
    value: 10,
    text_en: 'October',
    text_bn: 'অক্টোবর'
  },
  {
    value: 11,
    text_en: 'November',
    text_bn: 'নভেম্বর'
  },
  {
    value: 12,
    text_en: 'December',
    text_bn: 'ডিসেম্বর'
  }
]
const registrationTypeList = [
  {
      value: 1,
      text_en: 'Dealer',
      text_bn: 'ব্যবসায়ী'
  },
  {
      value: 2,
      text_en: 'Retailer',
      text_bn: 'খুচরা বিক্রেতা'
  }
]
export default {
  productTypeLists,
  monthList,
  registrationStatusList,
  registrationTypeList
}
